import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import EmailRecipientForm from "./component/EmailRecipientForm";
import EmailConfigService from "../../services/KangarooServices/EmailConfigService";
import DeleteModal from "../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const EmailRecipient = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };

  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await EmailConfigService.getRecipientList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedItem) {
      try {
        await EmailConfigService.deleteRecipient(selectedItem);
        fetchData();
        toast.success("Recipient deleted successfully");
      } catch (error) {
        toast.error("Delete failed");
      } finally {
        toggleDelete();
        setSelectedItem(null);
      }
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Email Recipient" pageTitle="Email Configuration" />

        <Row className="mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center ">
              <button className="btn btn-success" onClick={toggleModal}>
                <i className="bi bi-plus-lg"></i> New recipient
              </button>
            </div>
          </Col>
        </Row>

        <Row className="">
          {data?.map((item) => (
            <Col md={4} key={item.id}>
              <Card className="shadow-sm h-100 border-0 rounded-3 ">
                <CardBody className="d-flex flex-column justify-content-between">
                  {/* Name and Email */}
                  <div className="">
                    <h5 className=" fw-bold">
                      <i class="bx bx-user"></i> {item.name}
                    </h5>
                    <p className="d-flex justify-content-start align-content-center align-items-center  text-muted">
                      <i className="bx bx-envelope me-1"></i>
                      {item.email}
                    </p>
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <span className="fw-semibold me-2">Status:</span>
                    {item.isActive ? (
                      <span className="badge bg-success">Active</span>
                    ) : (
                      <span className="badge bg-danger">Inactive</span>
                    )}
                  </div>

                  {/* Form Pages */}
                  <div className="mb-3">
                    <strong>Forms:</strong>
                    {item.formPages?.length > 0 ? (
                      <div className="mt-1">
                        {item.formPages.map((page) => (
                          <span
                            key={page.id}
                            className="badge bg-primary me-2 mb-1 rounded-pill"
                          >
                            <i className="bx bx-file me-1"></i>
                            {page.name}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <p className="text-muted mb-0">No forms assigned</p>
                    )}
                  </div>
                </CardBody>

                {/* Actions */}
                <CardFooter className="bg-white border-top-0">
                  <div className="d-flex justify-content-end gap-2">
                    <Button
                      size="sm"
                      color="warning"
                      className="rounded-pill d-flex align-items-center gap-1"
                      onClick={() => toggleModal(item)}
                    >
                      <i className="bx bx-edit-alt"></i> Edit
                    </Button>

                    <Button
                      size="sm"
                      color="danger"
                      className="rounded-pill d-flex align-items-center gap-1"
                      onClick={() => handleDeleteClick(item.id)}
                    >
                      <i className="ri-delete-bin-5-line"></i> Delete
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <EmailRecipientForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedItem={selectedItem}
        fetchData={fetchData}
      />

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default EmailRecipient;
